// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sys-call-info > .sys-call-content[data-v-bdd31822] {
  flex: 6;
  padding-right: 10px;
  display: flex;
  justify-content: flex-end;
}
.sys-call-info[data-v-bdd31822] {
  min-height: 57px;
}
.sys-call-content .num[data-v-bdd31822],
.sys-call-content .time[data-v-bdd31822] {
  font-size: 30px;
  display: inline-block;
  height: 100%;
  line-height: normal;
  padding: 0px 5px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
